module.exports = __webpack_public_path__ + "static/img/仓库1@2x.6945047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/仓库1@2x.png
// module id = AZ+q
// module chunks = 1